import WebIM from "@/utils/WebIM";
import Vue from 'vue';
import { GetUserImInfo, AddIMMessage, GetJointGroups } from '@/service/webImApi.js'
import _, { upperCase } from 'lodash'

// import WebIM from "../utils/WebIM";

// TODO 处理页面刷新无法获取到音频url
const res = function(response) {
    let objectUrl = WebIM.utils.parseDownloadResponse.call(WebIM.conn, response);
    return objectUrl; //  'blob:http://localhost:8080/536070e2-b3a0-444a-b1cc-f0723cf95588'
};

function test(url, func) {
    let options = {
        url: url,
        headers: { Accept: "audio/mp3" },
        onFileDownloadComplete: func,
        onFileDownloadError: function() {
            console.log("音频下载失败");
        }
    };
    WebIM.utils.download.call(WebIM.conn, options);
}


const Chat = {
    state: {
        cPageType: location.href.indexOf('chatContentGroup') !== -1 ? 'group' : 'contact', //聊天页面的类型 有聊天类型 contact, group, chatroom
        cPageItem: {}, //聊天的点击项 默认是为空 
        username: '',
        userList: {
            contactUserList: [],
            groupUserList: [],
            chatroomUserList: []
        },
        msgList: {
            contact: {},
            group: {},
            chatroom: {},
        },
        currentMsgs: [],
        singleChatList: [],
        unreadAll: {
            contact: 0,
            group: 0,
        }
    },
    mutations: {
        setUnreadAll(state, obj) {
            state.unreadAll = obj || 0
        },
        setUserName(state, username) {
            state.username = username;
        },
        setCPageItem(state, item) {
            state.cPageItem = item;
        },
        setCPageType(state, type) {
            state.cPageType = type;
        },
        updateUserList(state, payload) {
            const { userList, type } = payload;
            state.userList[type] = userList;
        },
        updateMegUnread(state, sessionList) {
            let contactList = state.userList.contactUserList || [];
            let groupList = state.userList.groupUserList || [];
            console.log("groupList",groupList);
            let unreadAll = {
                contact: 0,
                group: 0,
            }
            for (let sessionI = 0; sessionI < sessionList.length; sessionI++) {
                let sessionId =  sessionList[sessionI].meta.id
                let sessionTo =  sessionList[sessionI].channel_id.split('#spim_')[1].split('@')[0]
                let sessionType = sessionList[sessionI].channel_id.split('#spim_')[1].split('@')[1]
                if(sessionType == 'easemob.com' &&  sessionTo !== this.state.hxLoginId) {
                    unreadAll.contact += -(-sessionList[sessionI].unread_num);
                }
                for (let userI = 0; userI < contactList.length; userI++) {
					if(sessionTo == contactList[userI].name) {   
						console.log("sessionId",sessionId,"sessionId",sessionTo,"sessionType",sessionType);
                        contactList[userI].unread_num = sessionList[sessionI].unread_num
                        contactList[userI].sessionId = sessionId
                        contactList[userI].sessionTo = sessionTo
                    }
                }
            }
            for (let sessionI = 0; sessionI < sessionList.length; sessionI++) {
                let sessionId =  sessionList[sessionI].meta.id
                let sessionTo =  sessionList[sessionI].channel_id.split('#spim_')[1].split('@')[0]
                let sessionType = sessionList[sessionI].channel_id.split('#spim_')[1].split('@')[1]
                if(sessionType == 'conference.easemob.com') {
                    unreadAll.group+= -(-sessionList[sessionI].unread_num);
                }
                for (let userI = 0; userI < groupList.length; userI++) {
					if(sessionTo == groupList[userI].groupid) {   
						console.log("sessionId",sessionId,"sessionId",sessionTo,"sessionType",sessionType);
                        groupList[userI].unread_num = sessionList[sessionI].unread_num
                        groupList[userI].sessionId = sessionId
                        groupList[userI].sessionTo = sessionTo
                    }
                }
            }
            console.log("%c getSessionList     onSetMessageRead","background:orange", sessionList,"unreadAll",unreadAll,"contactList",contactList,"groupList",groupList)
            state.userList = {
                contactUserList : contactList,
                groupUserList: groupList
            }
            state.unreadAll = unreadAll || { contact: 0, group: 0,}
        },
        updateMsgList(state, payload) {
            // console.log("++++++++++++++++++++++++++++++++    state",state,"payload",payload,"Object.keys(state.msgList.group)",Object.keys(state.msgList),"原先的长度是");
            const { chatType, chatId, msg, bySelf, type, id } = payload;
            let mid = this.state.chatId;
            let status = "unread";
            if (payload.chatType == "contact") {
                if (mid == payload.from) {
                    status = "read";
                }
                //单聊赋值成员头像和昵称
                let contactList = state.userList.contactUserList || [];
                for (let i = 0; i < contactList.length; i++) {
                    if (contactList[i].name == payload.from) {
                        payload['DisplayName'] = contactList[i].NickName;
                        payload['PhotoUrl'] = contactList[i].PhotoUrl;
                        payload['UserCode'] = contactList[i].UserCode;
                    }
                }
                let info = this.state.userInfo;
                if (info && info.ImUserId == payload.from) {
                    payload['DisplayName'] = info.LoginName;
                    payload['PhotoUrl'] = info.HeadImg;
                    payload['UserCode'] = info.UserCode;
                }
            } else if (payload.chatType == "group") {
                if (mid == payload.chatId) {
                    status = "read";
                }
                //群聊赋值群成员头像和昵称
                let members = this.state.group.groupInfo.members || [];
                for (let i = 0; i < members.length; i++) {
                    //登陆者自己
                    if (payload.bySelf == true) {
                        payload['from'] = this.state.hxLoginId;
                    }
                    if (payload.from == members[i].EasemobUserName) {
                        payload['DisplayName'] = members[i].DisplayName;
                        payload['PhotoUrl'] = members[i].PhotoUrl;
                        payload['UserCode'] = members[i].UserCode;
                        if (payload.from == this.state.hxLoginId) {
                            payload.bySelf = true
                        }
                    }
                }
            }

            if (!state.msgList[chatType][chatId]) {
                state.msgList[chatType][chatId] = [{
                    msg,
                    bySelf,
                    type: type || "",
                    mid: id,
                    status: status,
                    ...payload
                }];
            } else {
                state.msgList[chatType][chatId].push({
                    msg,
                    bySelf,
                    type: type || "",
                    mid: id,
                    status,
                    ...payload
                });

                state.msgList[chatType][chatId] = state.msgList[chatType][chatId].sort((a, b) => {
                    return a.time - b.time;
                });
            }
            if (chatType === "chatroom" && !bySelf) { // 聊天室消息去重处理
                state.currentMsgs = _.uniqBy(state.msgList[chatType][chatId], "mid");
            } else {
                state.currentMsgs = Object.assign([], state.msgList[chatType][mid || chatId]); // 这里params.id在路由跳转的时候会undefind，取chatId兼容
            }
            state.msgList = Object.assign({}, state.msgList);
            console.log("state.msgList",state.msgList);
            // Object.keys(state.msgList.group)['142752600883201'].length
            // console.log("Object.keys(state.msgList.group)",Object.keys(state.msgList),"现在的长度是 state.msgList", "currentMsgs",state.currentMsgs);
        },
        updateCurrentMsgList(state, messages) {
            state.currentMsgs = messages;
        },
        updateMessageMid(state, message) {
            let { id, mid } = message;
            let name = state.cPageType;
            Object.keys(state.msgList[name]).forEach((user) => {
                if (state.msgList[name][user].length) {
                    state.msgList[name][user].forEach((msg) => {
                        if (msg.mid == id) {
                            msg.mid = mid;
                        }
                    });
                }
            });
        },
        updateMessageStatus(state, message) {
            const { id, mid, action, readUser } = message;
            let name = state.cPageType;
            Object.keys(state.msgList[name]).forEach((user) => {
                if (action == "oneUserReadMsgs") {
                    if (state.msgList[name][readUser]) {
                        state.msgList[name][readUser].forEach((msg) => {
                            if (msg.status != "recall") {
                                msg.status = "read";
                            }
                        });
                    }
                } else if (state.msgList[name][user].length) {
                    state.msgList[name][user].forEach((msg) => {
                        if (action === "readMsgs" && !msg.bySelf) {
                            if (msg.status != "recall") {
                                msg.status = "read";
                            }
                        } else if (msg.mid == id || msg.mid == mid) {
                            msg.status = message.status;
                            if (message.msg) {
                                msg.msg = message.msg;
                            }
                        }
                    });
                }
            });
        },
        // 黑名单筛选用户列表
        changeUserList(state, payload) {
            let ary = [];
            _.forIn(payload, function(value, key) {
                ary.push({ name: key });
            });
            state.userList.contactUserList = _.pullAllBy(state.userList.contactUserList, ary, "name");
        },
        setSingleChatList(state, value) {
            console.log("value =====setSingleChatList", value);
            state.singleChatList = value || [];
        }
    },
    actions: {
        getSessionList: function(context, payload) {
            WebIM.conn.getSessionList().then(({data}) => {
                context.commit('updateMegUnread',data.channel_infos)   
                // console.log("%c getSessionList     onSetMessageRead","background:orange", data)
            })
        },
        onLogin: function(context, payload) {
            var options = {
                apiUrl: WebIM.config.apiURL,
                user: payload.username,
                pwd: payload.password,
                appKey: WebIM.config.appkey
            };
            context.commit('setHxLoginId', payload.username);
            WebIM.conn.open(options);
        },
        onLogout: function(context) {
            context.commit("setHxLoginId", "");
            localStorage.setItem("hxLoginId", "");
            WebIM.conn.close();
        },
        onGetContactUserList: function(context, payload) {
            try {
                WebIM.conn.getRoster({
                    success: function(roster) {
                        console.log("onGetContactUserList ", roster);
                        const userList = roster.filter(user => ["both", "to"].includes(user.subscription));
                        // console.log("userList ----===", userList);
                        let singleList = context.state.singleChatList;
                        // console.log("singleList ----", singleList);
                        let arr = [];
                        let nameList = [];
                        //根据返回的单聊列表展示当前单聊
                        for (let j = 0; j < singleList.length; j++) {
                            for (let i = 0; i < userList.length; i++) {
                                if (singleList[j].FriendImName == userList[i].name) {
                                    context.dispatch('getHistoryMessage', {
                                        name: singleList[j].FriendImName,
                                        isGroup: false,
                                        count: 1,
                                    });
                                    nameList.push(userList[i].name);
                                    let obj = {
                                        ...singleList[j],
                                        ...userList[i],
                                        NickName: singleList[j].FriendNickName,
                                        DisplayName: singleList[j].FriendNickName
                                    };
                                    arr.push(obj);
                                }
                            }
                        }
                        // console.log("arr === +++", arr);
                        context.commit("updateUserList", {
                            userList: arr,
                            type: "contactUserList",
                            black: payload
                        });
                        // context.dispatch('getSessionList')
                        //获取单聊成员昵称
                        // GetUserImInfo({
                        //     ImUserIds: nameList,
                        //     platform: 'pcweb'
                        // }).then(r => {
                        //     if (r.Result == 1) {
                        //         let infoList = r.Data.Lines || [];
                        //         for (let i = 0; i < arr.length; i++) {
                        //             for (let j = 0; j < infoList.length; j++) {
                        //                 if (arr[i].name == infoList[j].ImUserId) {
                        //                     extend(arr[i], infoList[j]);
                        //                 }
                        //             }
                        //         }
                        //         context.commit("updateUserList", {
                        //             userList: arr,
                        //             type: "contactUserList",
                        //             black: payload
                        //         });
                        //     }
                        // })
                        // context.commit("updateUserList", {
                        //     arr,
                        //     type: "contactUserList",
                        //     black: payload
                        // });
                    }
                });
            } catch (e) {
                console.log("error", e);
            }
        },
        onGetGroupUserList: function(context, payload) {
            var options = {
                success: function(resp) {
                    let userList = resp.data;
                    userList.forEach((user, index) => {
                        userList[index].name = user.groupname;
                        context.dispatch('getHistoryMessage', {
                            name: user.groupid,
                            isGroup: true,
                            count: 1,
                        })
                    });
                    context.commit("updateUserList", {
                        userList,
                        type: "groupUserList"
                    });
                    // context.dispatch('getSessionList')
                },
                error: function(e) {},
            };
            WebIM.conn.getGroup(options);
        },
        onGetChatroomUserList: function(context, payload) {
            var option = {
                apiUrl: window.location.protocol + "//a1.easemob.com",
                pagenum: 1, // 页数
                pagesize: 20, // 每页个数
                success: function(list) {
                    context.commit("updateUserList", {
                        userList: list.data,
                        type: "chatroomUserList"
                    });
                    // context.dispatch('getSessionList')
                },
                error: function() {
                    console.log("List chat room error");
                }
            };
            WebIM.conn.getChatRooms(option);
        },
        // 获取当前聊天对象的记录 @payload： {key, type}
        onGetCurrentChatObjMsg: function(context, payload) {
            const { id, type } = payload;
            let members = context.rootGetters.onGetGroupinfo.members || [];
            let chatList = context.state.msgList[context.state.cPageType][id] || [];
            //如果群信息已经获取到，显示群成员的昵称和头像
            if (context.state.cPageType == 'group' && members.length) {
                for (let i = 0; i < members.length; i++) {
                    for (let j = 0; j < chatList.length; j++) {
                        if (members[i].EasemobUserName == chatList[j].from) {
                            chatList[j]['DisplayName'] = members[i].DisplayName;
                            chatList[j]['PhotoUrl'] = members[i].PhotoUrl;
                            chatList[j]['UserCode'] = members[i].UserCode;
                        }
                    }
                }
            }
            console.log("获取当前聊天对象的记录  chatList", chatList);
            context.commit("updateCurrentMsgList", chatList);
        },
        onSetMessageRead: function(context, payload) {
            // console.log("%c onr  onSetMessageRead-------","background:yellow", payload,"context.rootState.hxLoginId",context.rootState.hxLoginId,"msg",msg);
            var msg = new WebIM.message('channel',WebIM.conn.getUniqueId());
           if(payload.chatType == 'group') { // 群聊的话
                msg.set({
                    to: payload.chatId.sessionTo,
                    chatType: 'groupChat'
                });
           }else { // 私聊的话
                msg.set({
                    to: payload.chatId.sessionTo
                });
           }
            WebIM.conn.send(msg.body);
        },
        onSendText: function(context, payload) {
            const { chatType, chatId, message } = payload;
            const id = WebIM.conn.getUniqueId();
            const time = +new Date();
            const chatroom = chatType === "chatroom";
            const type = chatType === "contact" ? "singleChat" : "groupChat";
            const jid = {
                contact: "name",
                group: "groupid",
                chatroom: "id"
            };
            const msgObj = new WebIM.message("txt", id);
            msgObj.set({
                msg: message,
                to: chatId[jid[chatType]],
                chatType: type,
                roomType: chatroom,
                success: function(res) {
                    context.commit("updateMsgList", {
                        chatType,
                        chatId: chatId[jid[chatType]],
                        msg: message,
                        bySelf: true,
                        time: time,
                        mid: id,
                        status: "sending"
                    });
                    context.dispatch('sendMsgCall', {
                        chatId: chatId[jid[chatType]],
                        chatType
                    });
                },
                fail: function(e) {
                    console.log("Send private text error", e);
                }
            });
            if (chatType === "group" || chatType === "chatroom") {
                msgObj.setGroup("groupchat");
            }
            WebIM.conn.send(msgObj.body);
        },
        sendImgMessage: function(context, payload) {
            const { chatType, chatId, roomType, file, callback } = payload;
            const id = WebIM.conn.getUniqueId();
            const jid = {
                contact: "name",
                group: "groupid",
                chatroom: "id"
            };
            const msgObj = new WebIM.message("img", id);
            msgObj.set({
                apiUrl: WebIM.config.apiURL,
                file: file,
                to: chatId[jid[chatType]],
                roomType: roomType,
                onFileUploadError: function(error) {
                    console.log("图片上传失败", error);
                    callback();
                },
                onFileUploadComplete: function(data) {
                    let url = data.uri + "/" + data.entities[0].uuid;
                    context.commit("updateMsgList", {
                        msg: url,
                        chatType,
                        chatId: chatId[jid[chatType]],
                        bySelf: true,
                        type: "img",
                        time: data.timestamp,
                        mid: id,
                        status: "sending"
                    });
                    callback();
                },
                success: function() {
                    context.dispatch('sendMsgCall', {
                        chatId: chatId[jid[chatType]],
                        chatType
                    });
                    console.log("图片发送成功");
                }
            });
            if (chatType === "group" || chatType === "chatroom") {
                msgObj.setGroup("groupchat");
            }
            WebIM.conn.send(msgObj.body);
        },
        sendFileMessage: function(context, payload) {
            const { chatType, chatId, roomType, file, callback } = payload;
            const id = WebIM.conn.getUniqueId();
            const jid = {
                contact: "name",
                group: "groupid",
                chatroom: "id"
            };
            const msgObj = new WebIM.message("file", id);
            // console.log("chatTypechatTypechatTypechatTypechatTypechatTypechatType",chatType);
            msgObj.set({
                apiUrl: WebIM.config.apiURL,
                file: file,
                ext: {
                    file_length: file.data.size
                },
                to: chatId[jid[chatType]],
                roomType: roomType,
                onFileUploadError: function(error) {
                    console.log("文件上传失败", error);
                    callback();
                },
                onFileUploadComplete: function(data) {
                    let url = data.uri + "/" + data.entities[0].uuid;
                    context.commit("updateMsgList", {
                        msg: url,
                        chatType,
                        chatId: chatId[jid[chatType]],
                        bySelf: true,
                        type: "file",
                        filename: file.data.name,
                        file_length: file.data.size,
                        time: data.timestamp,
                        mid: id,
                        status: "sending"
                    });
                    callback();
                },
                success: function() {
                    context.dispatch('sendMsgCall', {
                        chatId: chatId[jid[chatType]],
                        chatType
                    });
                    console.log("文件发送成功");
                }
            });
            if (chatType === "group" || chatType === "chatroom") {
                msgObj.setGroup("groupchat");
            }
            WebIM.conn.send(msgObj.body);
        },
        sendRecorder: function(context, payload) {
            const { useId, type, file } = payload;
            const id = WebIM.conn.getUniqueId();
            const msgObj = new WebIM.message("audio", id);
            let isRoom = type == "chatroom" || type == "groupchat";

            const jid = {
                contact: "name",
                group: "groupid",
                chatroom: "id"
            };

            // console.log('bold>>>', bold);
            // console.log('newBold>>', WebIM.utils.parseDownloadResponse.call(WebIM.conn, bold));
            // let newBold = WebIM.utils.parseDownloadResponse.call(WebIM.conn, bold)
            // var file = WebIM.utils.getFileUrl(input);
            msgObj.set({
                apiUrl: WebIM.config.apiURL,
                file: file,
                to: useId,
                type: "audio",
                roomType: isRoom,

                onFileUploadError: function(error) {
                    console.log("语音上传失败", error);
                },
                onFileUploadComplete: function(data) {
                    console.log("上传成功", data);
                    let url = data.uri + "/" + data.entities[0].uuid;
                    context.commit("updateMsgList", {
                        msg: url,
                        chatType: type,
                        chatId: useId,
                        bySelf: true,
                        type: "audio",
                        filename: file.data.name,
                        // file_length: file.data.size,
                        // time: data.timestamp,
                        mid: id,
                        status: "sending"
                    });
                },
                success: function(data) {
                    context.dispatch('sendMsgCall', {
                        chatId: useId,
                        chatType: type
                    });
                    console.log("语音发送成功", data);
                },
                flashUpload: WebIM.flashUpload
            });

            if (type === "group" || type === "chatroom") {
                msgObj.setGroup("groupchat");
            }
            WebIM.conn.send(msgObj.body);
        },
        onCallVideo: function(context, payload) {
            console.log('onCallVideo      888888=',payload);
            const { chatType, to } = payload;
            const type = chatType === "contact" ? "singleChat" : "groupChat";
            const hxLoginId = context.rootState.hxLoginId;
            if (chatType === "contact") {
                // this.setState({
                //     showWebRTC: true
                // })
                WebIM.call.caller = hxLoginId;
                WebIM.call.makeVideoCall(to, null, payload.rec, payload.recMerge);
                context.dispatch('sendMsgCall', {
                    chatId: to,
                    chatType
                });
            }
        },
        onCallVoice: function(context, payload) {
            const { chatType, to } = payload;
            const type = chatType === "contact" ? "singleChat" : "groupChat";
            const hxLoginId = context.rootState.hxLoginId;
            console.log("onCallVoice chatType",chatType);
            if (chatType === "contact") {
                WebIM.call.caller = hxLoginId;
                WebIM.call.makeVoiceCall(to, null, payload.rec, payload.recMerge);
                context.dispatch('sendMsgCall', {
                    chatId: to,
                    chatType
                });
            }
        },

        getHistoryMessage: function(context, payload) {
            const options = {
                queue: payload.name,
                isGroup: payload.isGroup,
                count: payload.count || 10, // 每次获取消息条数
                success: function(msgs) {
                    try {
                        payload.success && payload.success(msgs);
                        if (msgs.length) {
                            const hxLoginId = context.rootState.hxLoginId;
                            msgs.forEach((item) => {
                                let time = Number(item.time);
                                let msg = {};
                                const bySelf = item.from == hxLoginId;
                                //判断消息是否是图片类型
                                let filename = item.filename || '';
                                let isImg = false;
                                let fileExt = filename.indexOf('.') > -1 ? filename.substring(filename.lastIndexOf('.') + 1) : '';
                                let imgExt = 'PNG,JPEG,JPG,GIF,BMP';
                                if (fileExt && imgExt.indexOf(upperCase(fileExt)) > -1) {
                                    isImg = true;
                                }
                                if (!filename) {
                                    //文字消息
                                    msg = {
                                        chatType: payload.isGroup ? "group" : "contact",
                                        chatId: bySelf ? item.to : item.from,
                                        from: item.from,
                                        msg: item.data,
                                        bySelf: bySelf,
                                        time: time,
                                        mid: item.id,
                                        status: "read",
                                        type: 'text',
                                        ext: item.ext,
                                    };
                                    if (payload.isGroup) {
                                        msg.chatId = item.to;
                                    } else {
                                        msg.chatId = bySelf ? item.to : item.from;
                                    }
                                } else if (!item.ext.file_length && isImg) { // 为图片的情况
                                    //图片消息
                                    msg = {
                                        msg: item.url,
                                        chatType: payload.isGroup ? "group" : "contact",
                                        chatId: bySelf ? item.to : item.from,
                                        from: item.from,
                                        bySelf: bySelf,
                                        type: "img",
                                        time: time,
                                        mid: item.id,
                                        status: "read"
                                    };
                                    if (payload.isGroup) {
                                        msg.chatId = item.to;
                                    } else {
                                        msg.chatId = bySelf ? item.to : item.from;
                                    }
                                } else if (filename === "audio") {
                                    //音频消息
                                    msg = {
                                        msg: item.url,
                                        chatType: payload.isGroup ? "group" : "contact",
                                        chatId: bySelf ? item.to : item.from,
                                        from: item.from,
                                        time: time,
                                        bySelf: bySelf,
                                        type: "audio"
                                    };
                                    if (payload.isGroup) {
                                        msg.chatId = item.to;
                                    } else {
                                        msg.chatId = bySelf ? item.to : item.from;
                                    }
                                } else if (filename.substring(item.filename.length - 3) === "mp4") {
                                    //视频消息
                                    msg = {
                                        msg: item.url,
                                        chatType: payload.isGroup ? "group" : "contact",
                                        chatId: bySelf ? item.to : item.from,
                                        from: item.from,
                                        time: time,
                                        bySelf: bySelf,
                                        type: "video"
                                    };
                                    if (payload.isGroup) {
                                        msg.chatId = item.to;
                                    } else {
                                        msg.chatId = bySelf ? item.to : item.from;
                                    }
                                } else {
                                    //文件消息
                                    msg = {
                                        msg: item.url,
                                        chatType: payload.isGroup ? "group" : "contact",
                                        chatId: bySelf ? item.to : item.from,
                                        from: item.from,
                                        bySelf: bySelf,
                                        type: "file",
                                        filename: item.filename,
                                        file_length: item.file_length,
                                        time: time,
                                        mid: item.id,
                                        status: "read"
                                    };
                                    if (payload.isGroup) {
                                        msg.chatId = item.to;
                                    } else {
                                        msg.chatId = bySelf ? item.to : item.from;
                                    }
                                }
                                msg.isHistory = true;
                                context.commit("updateMsgList", msg);
                            });
                            context.commit("updateMessageStatus", { action: "readMsgs" });
                        }
                    } catch (e) {
                        console.log("error", e);
                    }
                },
                fail: function() {}
            };
            WebIM.conn.fetchHistoryMessages(options);
        },

        recallMessage: function(context, payload) {
            const { chatType, mid } = payload.message;
            const to = payload.to;
            const me = this;
            const chatTypeObj = {
                contact: "chat",
                group: "groupchat",
                chatroom: "chatroom"
            };
            const option = {
                mid,
                to,
                type: chatTypeObj[chatType],
                success: function() {
                    payload.message.status = "recall";
                    payload.message.msg = "消息已撤回";
                    Vue.$store.commit("updateMessageStatus", payload.message);
                },
                fail: function() {
                    // me.$message('消息撤回失败');
                },
            };
            WebIM.conn.recallMessage(option);
        },
        sendMsgCall: function(context, payload) {
            //投标成功，发单方发送消息之后，接单方才能聊天
            if (payload.chatType != "contact") {
                return;
            }
            let target = payload.chatId.substring(payload.chatId.lastIndexOf('-') + 1);
            let userCode = this.state.userInfo.UserCode;
            AddIMMessage({
                platform: 'pcweb',
                JobID: 0,
                IsPrivateChat: true,
                FromUserCode: userCode,
                ToUserCode: target,
            })
        }

    },
    getters: {
        onGetContactUserList(state) {
            return state.userList.contactUserList;
        },
        onGetGroupUserList(state) {
            return state.userList.groupUserList;
        },
        onGetChatroomUserList(state) {
            return state.userList.chatroomUserList;
        },
        onGetCurrentChatObjMsg(state) {
            // 不要去重了 
            // if (state.currentMsgs instanceof Array) {
            //     return _.uniqBy(state.currentMsgs, 'mid');
            // } else {
            return state.currentMsgs;
            // }
        },
        fetchHistoryMessages(state) {
            return state.currentMsgs;
        },
        onSingleChatList(state) {
            return state.singleChatList
        },
        getUnreadAll(state) {
            return state.unreadAll
        }
    }

};
export default Chat;